import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Debug environment variables
console.log('Environment check:', {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  hostname: window.location.hostname
});

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCxHLcF_cD-0q_Me8tHjjqpsiLRCfqGXxI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "boutee-app.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "boutee-app",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "boutee-app.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "998810217636",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:998810217636:web:d29cbb69d29b4a4c9bca31",
  measurementId: "G-ZMXKY5K21Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Connect to emulators ONLY when explicitly requested
/*
if (process.env.REACT_APP_ENV === 'development' && window.location.hostname === "localhost") {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099');
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectStorageEmulator(storage, 'localhost', 9199);
    console.log('🔧 Connected to Firebase emulators');
  } catch (error) {
    console.log('Emulators already connected or not available');
  }
} else {
  console.log('🚀 Connected to production Firebase');
}
*/

// Enhanced event service for component communication
class EventService {
  constructor() {
    this.events = {};
  }

  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
    
    return () => {
      this.events[event] = this.events[event].filter(cb => cb !== callback);
      
      if (this.events[event].length === 0) {
        delete this.events[event];
      }
    };
  }

  emit(event, data) {
    if (this.events[event]) {
      this.events[event].forEach(callback => callback(data));
    }
  }
  
  getListeners(event) {
    return this.events[event] ? this.events[event].length : 0;
  }
}

const eventService = new EventService();

export { auth, db, storage, eventService, functions, app };